import { FC } from "react";
import PartnerWebLayout from "./WebLayout";

const Partner: FC = () => {
  return (
    <div>
      <PartnerWebLayout />
    </div>
  );
};

export default Partner;
